import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Presentation, Sparkles, Calendar, Clock, 
  FileText, TrendingUp, ArrowRight 
} from 'lucide-react';

const DigiPresentorLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: "AI-Powered Scripts",
      description: "Generate professional networking presentation scripts with AI"
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Weekly Rotations",
      description: "Automatically rotate through 4 unique weekly scripts"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Timed Presentations",
      description: "Scripts optimized for 30-second and 60-second presentations"
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: "Custom Templates",
      description: "Create and save your own presentation templates"
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Track Performance",
      description: "Monitor which presentations generate the most interest"
    },
    {
      icon: <Presentation className="w-8 h-8" />,
      title: "Professional Format",
      description: "Perfectly formatted for networking groups and business presentations"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-slate-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-teal-600">Presentor</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            AI-Powered Networking Presentation Scripts - Never Run Out of Things to Say
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Generate Scripts <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/presentor')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-teal-600 text-teal-600 hover:bg-teal-50"
            >
              See Examples
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-teal-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Master Your Networking Presentations
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join professionals using AI to create compelling presentations
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Start Creating Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiPresentorLanding;